/*
 * LoginPage Messages
 *
 * This contains all the text for the LoginPage component.
 */
import { defineMessages } from 'react-intl';

const scope = 'login';

export default defineMessages({
  welcome: {
    id: `${scope}.welcome`,
    defaultMessage: 'Welcome back',
  },
  email: {
    id: `${scope}.email`,
    defaultMessage: 'Email Address',
  },
  password: {
    id: `${scope}.password`,
    defaultMessage: 'Password',
  },
  emailEmptyFeedback: {
    id: `${scope}.email.feedback.empty`,
    defaultMessage: 'Email Address cannot be empty.',
  },
  passwordEmptyFeedback: {
    id: `${scope}.password.feedback.empty`,
    defaultMessage: 'Password cannot be empty.',
  },
  submit: {
    id: `${scope}.submit`,
    defaultMessage: 'Login',
  },
  remember: {
    id: `${scope}.remember`,
    defaultMessage: 'Keep me signed in',
  },
  iesV2: {
    id: `${scope}.iesV2`,
    defaultMessage: 'Login via IES',
  },
});
